import { useNavigate } from "react-router";
import { toast } from "sonner";

import { EnlaceVolver } from "@/components/EnlaceVolver";
import { manejarErrorDeGuardado } from "@/components/perfiles/errores";
import { PerfilFormulario } from "@/components/perfiles/PerfilFormulario";
import { usePerfiles, useCrearPerfil } from "@/hooks/usePerfiles";

/** Pantalla 11 SA — alta de perfil. Un solo campo: el nombre. */
export function PerfilNuevo() {
  const navigate = useNavigate();
  const perfiles = usePerfiles();
  const crear = useCrearPerfil();

  const existentes = perfiles.data?.map((p) => p.nombre).join(", ");

  return (
    <div className="space-y-5 px-6 pt-2 pb-6 lg:px-8 lg:pb-8">
      <EnlaceVolver to="/admin/perfiles">Volver a perfiles</EnlaceVolver>

      <p className="text-muted-foreground max-w-[40rem] text-sm">
        Los perfiles definen qué tipo de acceso tendrá cada usuario.
        {existentes ? ` Perfiles actuales: ${existentes}.` : ""}
      </p>

      <PerfilFormulario
        etiquetaEnvio="Crear perfil"
        enviando={crear.isPending}
        onEnviar={(nombre, { errorDeNombre }) =>
          crear.mutate(
            { nombre },
            {
              onSuccess: (perfil) => {
                toast.success(`Perfil «${perfil.nombre}» creado`);
                navigate("/admin/perfiles");
              },
              onError: (error) =>
                manejarErrorDeGuardado(
                  error,
                  errorDeNombre,
                  "No pudimos crear el perfil. Inténtalo de nuevo.",
                ),
            },
          )
        }
      />
    </div>
  );
}
